import { render, staticRenderFns } from "./InspectionsSummaryTable.vue?vue&type=template&id=b82d25ac&scoped=true"
import script from "./InspectionsSummaryTable.vue?vue&type=script&lang=js"
export * from "./InspectionsSummaryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82d25ac",
  null
  
)

export default component.exports